import React, {h, Component} from 'preact';
import {PropTypes} from 'preact-compat';

export default class FloatLabelInput extends Component {
    static get propTypes() {
        return {
            inputId: PropTypes.string,
            inputClass: PropTypes.string,
            required: PropTypes.bool,
            checkMarkEnabled: PropTypes.bool,
            label: PropTypes.string,
            errorLabel: PropTypes.string,
            renderIcon: PropTypes.func,
            defaultValue: PropTypes.string,
            value: PropTypes.string,
            onInput: PropTypes.func,
            onChange: PropTypes.func
        };
    }

    state = {
        floating: !!this.props.value || !!this.props.defaultValue
    };

    handleInput = event => {
        this.setState({floating: !!event.target.value});

        if (this.props.onInput) {
            this.props.onInput(event);
        }
    };

    handleChange = event => {
        this.setState({floating: !!event.target.value});

        if (this.props.onChange) {
            this.props.onChange(event);
        }
    };

    render() {
        const {floating} = this.state;
        const {
            inputClass,
            inputId,
            required,
            checkMarkEnabled,
            label,
            errorLabel,
            renderIcon,
            ...inputProps
        } = this.props;

        return (
            <div className={`float-label-div ${errorLabel != null ? 'error' : ''} ${required ? 'required' : ''}`}>
                <div style={{position: 'relative'}}>
                    <input
                        {...inputProps}
                        id={inputId}
                        className={`${floating ? 'floating' : ''} ${inputClass} ${required ? 'required' : ''}`}
                        onInput={this.handleInput}
                        onChange={this.handleChange}
                    />
                    {checkMarkEnabled && !errorLabel && floating &&
                        <div className="check-mark"><i className="icon-nav-check"/></div>
                    }
                    {renderIcon && renderIcon()}
                </div>
                <label
                    htmlFor={inputId}
                    className={`float-label ${floating ? 'collapsed' : ''} ${required ? 'required' : ''}`}>
                    {label}
                </label>
                <label
                    htmlFor={inputId}
                    generated="true"
                    className="error"
                    style={{display: errorLabel ? 'inline-block' : 'none'}}>
                    {errorLabel}
                </label>
            </div>
        );
    }
}
